export default "/images/ic_mbway.svg?7fb6682571ba5c279078e359a850e9ae";